import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { VideoLinkService } from './video-link.service';
import { ConfirmationService } from 'primeng/api';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { ReferenceLibraryService } from 'reference-library';

@Component({
  selector: 'app-video-call-link',
  templateUrl: './video-call-link.component.html',
  styleUrls: ['./video-call-link.component.scss']
})
export class VideoCallLinkComponent implements OnInit {
  videoLink;
  userId;
  videoLinkId

  constructor( public dialog: MatDialog,  private referenceLibraryService: ReferenceLibraryService, private authenticationService: AuthenticationService, private toastr: ToastrService, private videoLinkService: VideoLinkService) { }

  ngOnInit(): void {
  this.authenticationService.currentUser.subscribe((data) => {
    if (data) {
      this.userId = data.userId
      this.getVideoLink()
    }
  })
  }

  ngAfterViewInit() {
    this.translet();
  }

  translet() {
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);
  }

  getVideoLink() {
    this.videoLinkService.getVideoLink(this.userId).subscribe(
      (res: any)=> {
        this.videoLink = res?.data?.settingValue;
        this.videoLinkId = res?.data?.id;
      }
    )
  }
  
  dialogueInitializer(event, title: string, buttons: any[]) {
    const cordinates: MouseEventInit = event;
    const message = 'Do you really want to delete the link?'
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '40%',
      data: {
        update: { title, message },
        buttons: buttons
      }
    });
    return dialogRef;
  }

  confirmationPopup() {
    const title = 'Confirm';
    const buttons = ['No', 'Yes'];
    this.dialogueInitializer(event, title, buttons).afterClosed().subscribe(result => {
      if (result) {
        this.deleteVideoLink();
      }
    });
  }

  saveVideoLink() {
    let payload = {
      settingId: 0,
      settingValue: this.videoLink,
      userId: this.userId,
      id: 0    
    };
    if(this.videoLinkId) {
      payload.id = this.videoLinkId
    }
    this.videoLinkService.saveVideoLink(payload).subscribe(
      (res: any)=> {
        this.toastr.success(res.message);
        this.videoLink = res?.data?.settingValue;
        this.videoLinkId = res?.data?.id;
      }
    )
  }

  deleteVideoLink(){
    this.videoLinkService.deleteVideoLink(this.videoLinkId).subscribe(
      (res: any)=> {
        this.toastr.success(res.message);
        this.videoLink = null;
        this.videoLinkId = null;
      }
    )
  }

}
